export enum ComplianceRegion {
  EU = 'EU',
  USA = 'USA',
  AU = 'AU',
  NONE = 'NONE',
  UK = 'UK',
  IS = 'IS',
  FI = 'FI'
}
